import axios, { AxiosResponse } from "axios";
import { useRecoilState } from "recoil";
import { controlTowerAtom } from "Recoil/controlTower.atom";
import errorHandler from "Utils/error-handler";
import { setWithExpiry, getWithExpiry } from "Helpers/getset-with-expiry";
import { findIndex, reduce, omitBy, isEmpty, isNil, toLower } from "lodash";
import useSession from "Hooks/session.hook";
import { getAccessToken } from "Helpers/session";
import { RiderType } from "Types/new_driver_types";
import { UserRoleToAssign } from "Types/user.types";

let globalSSE: EventSource;
// const [eventData, setEventData] = useRecoilState(controlTowerAtom);

export const sessionCreate = async () => {
  const url = `${process.env.API_URL}/${process.env.API_VER}`;
  const accessToken = getAccessToken();
  const appSession = getWithExpiry(`${process.env.APP_SESSION}`);
  const org = appSession.org;
  try {
    const response = await axios({
      method: "POST",
      url: `${url}/controltower/session/create`,
      data: {
        admin: {
          orgID: org._id,
          profileID: appSession.roles[0].profileID,
        },
        data: {
          orgID: org._id,
          orgType: org.orgType,
          profileID: appSession.roles[0].profileID,
          userRole: appSession.roles[0].subType,
        },
      },
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (response.data?.created == true) {
      localStorage.setItem("CONTROL_TOWER_TOKEN", response.data.accessToken);
      globalSSE = subscribeEventsource();
      console.log("session created");
    }

    return globalSSE;
  } catch (err: any) {
    const { error } = err.response?.data || {};
    console.log(err.response);

    if (!isEmpty(error)) {
      const callback = async () => await sessionCreate();
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};

export const subscribeEventsource = async () => {
  const url = `${process.env.CT_MICROSERVICE_URL}`;
  const msToken = localStorage.getItem("CONTROL_TOWER_TOKEN");

  try {
    globalSSE = new EventSource(`${url}/controltower/subscribe/${msToken}`);

    handleControlEventListeners(globalSSE);
    return globalSSE;
  } catch (err: any) {
    const { error } = err.response?.data || {};
    console.log(err.response);

    if (!isEmpty(error)) {
      const callback = async () => await subscribeEventsource();
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};

export const handleControlEventListeners = (sse) => {
  const SseStatus = {
    0: "connecting",
    1: "open",
    2: "closed",
  };

  sse.addEventListener("FIRST_MILE", (sse_event) => {
    console.log(`FIRST_MILE : ${sse_event.data}`);
    // setEventData((prevData) => ({ ...prevData, firstMile: sse_event.data }));
  });

  sse.addEventListener("MID_MILE", (sse_event) => {
    console.log(`MID_MILE : ${sse_event.data}`);
    // setEventData((prevData) => ({ ...prevData, midMile: sse_event.data }));
  });

  sse.addEventListener("LAST_MILE", (sse_event) => {
    console.log(`LAST_MILE : ${sse_event.data}`);
    // setEventData((prevData) => ({ ...prevData, lastMile: sse_event.data }));
  });

  sse.addEventListener("timestamp", (sse_event) => {
    console.log(`time stamp : ${sse_event.data}`);
    // setEventData((prevData) => ({ ...prevData, timestamp: sse_event.data }));
  });

  sse.addEventListener("error", (sse_event) => {
    console.log(`error heree : ${SseStatus[sse.readyState]}`);
  });

  // sse.addEventListener("error", (error_event)=> {
  //     alert(JSON.stringify(error_event))
  //     console.log(error_event)
  //     Disconnect()
  // })
};

export const sessionDisconnect = async (sse) => {
  if (sse) {
    sse.close();
    console.log("Session closed");
  }
};

//Store in recoil state here

export const listDashboardData = async (filters) => {
  const url = `${process.env.API_URL}/${process.env.API_VER}`;
  const accessToken = getAccessToken();
  const { org, profile } = useSession();

  try {
    const response = await axios({
      method: "POST",
      url: `${url}/controltower/dashboard/data/list`,
      data: {
        admin: {
          orgID: org._id,
          profileID: profile._id,
        },
        data: filters,
      },
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return response.data[0];
  } catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await listDashboardData(filters);
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};

export const listFirstMile = async (filters: any) => {
  const url = `${process.env.API_URL}/${process.env.API_VER}`;
  const accessToken = getAccessToken();
  const { org, profile } = useSession();

  try {
    const response = await axios({
      method: "POST",
      url: `${url}/controltower/firstmile/data/list`,
      data: {
        admin: {
          orgID: org._id,
          profileID: profile._id,
        },
        data: filters,
      },
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return response.data;
  } catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await listFirstMile(filters);
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};

export const listCustomerFirstMile = async (filters: any) => {
  const url = `${process.env.API_URL}/${process.env.API_VER}`;
  const accessToken = getAccessToken();
  const { org, profile } = useSession();

  try {
    const response = await axios({
      method: "POST",
      url: `${url}/controltower/firstmile/customer_data/list`,
      data: {
        admin: {
          orgID: org._id,
          profileID: profile._id,
        },
        data: filters,
      },
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return response.data;
  } catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await listCustomerFirstMile(filters);
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};

export const listMidMile = async (filters) => {
  const url = `${process.env.API_URL}/${process.env.API_VER}`;
  const accessToken = getAccessToken();
  const { org, profile } = useSession();

  try {
    const response = await axios({
      method: "POST",
      url: `${url}/controltower/midmile/data/list`,
      data: {
        admin: {
          orgID: org._id,
          profileID: profile._id,
        },
        data: filters,
      },
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return response.data;
  } catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await listMidMile(filters);
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};

export const listCustomerMidMile = async (filters) => {
  const url = `${process.env.API_URL}/${process.env.API_VER}`;
  const accessToken = getAccessToken();
  const { org, profile } = useSession();

  try {
    const response = await axios({
      method: "POST",
      url: `${url}/controltower/midmile/customer_data/list`,
      data: {
        admin: {
          orgID: org._id,
          profileID: profile._id,
        },
        data: filters,
      },
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return response.data;
  } catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await listCustomerMidMile(filters);
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};

export const listLastMile = async (filters) => {
  const url = `${process.env.API_URL}/${process.env.API_VER}`;
  const accessToken = getAccessToken();
  const { org, profile } = useSession();

  try {
    const response = await axios({
      method: "POST",
      url: `${url}/controltower/lastmile/data/list`,
      data: {
        admin: {
          orgID: org._id,
          profileID: profile._id,
        },
        data: filters,
      },
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return response.data;
  } catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await listLastMile(filters);
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};

export const listCustomerLastMile = async (filters) => {
  const url = `${process.env.API_URL}/${process.env.API_VER}`;
  const accessToken = getAccessToken();
  const { org, profile } = useSession();

  try {
    const response = await axios({
      method: "POST",
      url: `${url}/controltower/lastmile/customer_data/list`,
      data: {
        admin: {
          orgID: org._id,
          profileID: profile._id,
        },
        data: filters,
      },
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return response.data;
  } catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await listCustomerLastMile(filters);
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};

export const getRouteFromNbApi = async (filterStr) => {
  const url = `https://api.nextbillion.io/directions/json?key=${process.env.NEXT_BILLION_KEY}${filterStr}&steps=false&alternatives=false&departure_time=0&session=&geometry=polyline6&waypoints=3.123261,101.726962`;
  // const accessToken = getAccessToken();
  // const { org, profile } = useSession();

  try {
    const response = await axios({
      method: "GET",
      url: `${url}`,
    });
    return response;
  } catch (err: any) {
    const { error } = err.response?.data || {};
    console.log(err.message);
    return { error: { message: err.message } };
  }
};
